import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectEventTrackerVM, EventTrackerContext } from './event-tracker.context';
import { ManageEventTrackerPresentation } from './manage-event-tracker.presentation';
import { ManageEventTrackerViewModal } from './manage-event-tracker.viewmodel';

interface IProps {
    vm: ManageEventTrackerViewModal;
}

const EventTrackerContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    }, []);

    return <ManageEventTrackerPresentation vm={vm} />;
};

const EventTrackerConnected = connectEventTrackerVM<IProps>(EventTrackerContainer, vm => ({ vm: vm }));

export const ManageEventTracker = moduleHost(ManageEventTrackerViewModal, EventTrackerContext, EventTrackerConnected);
